import React from "react";
import "./Blogs.css";
import Services from "../Services/Services";

const Blogs = () => {
  return (
    <section>
      <Services></Services>
    </section>
  );
};

export default Blogs;
